<template>
    <div class="banners_container">
        <div class="banners">
            <img :src="src" alt="">
        </div>
    </div>
</template>
<script>
export default {
    props:['src']
}
</script>
<style lang="scss" scoped>
@media (min-width: 1200px) {
	@import '../style/base.scss';
	.banners{
        width: 100%;
        height: 100vh;
        display: block;
        img{
            display: block;  
            width: 100%;
            height: 100%;
        }
    }
}
@media (max-width: 1199px) {
	@import '../style/mb.scss';
    .banners_container{
        padding: 0 rm(20);
    }
	.banners{
        height: rm(220);
        margin: rm(10) 0 rm(30);
        img{
            display: block;  
            width: 100%;
            height: 100%;
        }
    }
	
}
</style>